module.exports = __webpack_public_path__ + "media/images/hn-2-5a1ece16.jpg";